import req from './axios.js' //引入封装好的axios
import config from '@/config/config.js';
const PATH=config.apiPath
const api = {};
//获取会议跟进列表数据
api.getMeetingFollowUp= (params, callback) => req(PATH + "/plm/api/saas/reviewMeeting/meetingFollowUp", "get", params, callback);
//会议列表数据
api.getPurchaseOrder=(params, callback) => req(PATH + "/plm/api/saas/purchaseOrder", "get", params, callback);

export default api;